export const globalSettingsAddonsOauthRoute = {
	name: 'global-settings-addons-oauth',
	path: '/secure/oauth-credentials',
};
